import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 10); // Delay for dom to be updated completely first

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
